import { Department } from ".";

export class Affiliation {
  constructor(
    public mainDepartment: Department,
    public departments: Department[],
  ) {
  }
}
